import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingConfigurationItemCategoryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/ItemSpec/ItemSpecBrowser")
	}

	render() {
		return (
			<Activity 
				name="ItemSpec"
				RenderedComponent={this.RenderedComponent}
				context="ItemSpec"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingConfigurationItemCategoryActivity)
